export const columnsRole = [
    {
      accessor: "id",
    },
    {
      Header: "ROLE NAME",
      accessor: "role_name",
    },
    {
      Header: "DESCRIPTION",
      accessor: "role_desc",
    },
    // {
    //   Header: "ACTIVE",
    //   accessor: "active",
    // },
    // {
    //   Header: "ROLE",
    //   accessor: "role",
    // },
    {
      Header: "UPDATE",
      accessor: "update",
    },
    // {
    //   Header: "DISABLE",
    //   accessor: "disable",
    // },
    // {
    //   Header: "DELETE",
    //   accessor: "delete",
    // },
  ];
  